import EventHomeScheduleAction from '@/screens/EventHomeScheduleAction';

export default function PrivateEventCalendarIndexRoute() {
  return <EventHomeScheduleAction />;
}
